<ng-container>
  <span>{{ text }}</span>
  <a *ngIf="!showOnlyText" [ngStyle]="{ color: linkColor, cursor: 'pointer' }" (click)="toggleLength()">
    <span *ngIf="!hide">...show more</span>
    <span *ngIf="hide">...show less</span>
  </a>
</ng-container>
